import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';
import { BundleCandidatesResponse } from '@trade-platform/ui-shared';

@Injectable()
export class OrderBundleCandidatesService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    getBundleCandidates(orderId: string): Observable<BundleCandidatesResponse> {
        return this.http.get<BundleCandidatesResponse>(
            `${this.environment.api}orders/${orderId}/bundleCandidates`
        );
    }
}
